export default __webpack_public_path__ + "static/210521_妲絲刷關活動熱更預告_en-ef11190aa855eaa47a9015c18562cea9.webp";